import { EventBusFacade } from "remote-module-context";
import { Observable } from "rxjs";

export function observeEvent<T>(eventBus: EventBusFacade, event: string): Observable<T> {
	return new Observable<T>((subscriber) =>
		eventBus.subscribe({
			event,
			eventHandler: (payload: T) => subscriber.next(payload),
		})
	);
}
